import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { Icon } from 'ui';

export type ProducerPillIcon = 'location-pin-icon' | 'distributor-icon';

interface ProducerPillProps {
  label: string;
  name: string;
  to?: string;
  icon?: ProducerPillIcon;
  cooperative?: boolean;
}

export const ProducerPill = ({
  label,
  name,
  to,
  icon = 'location-pin-icon',
  cooperative = false,
}: ProducerPillProps) => {
  const intl = useIntl();
  const cooperativeTitle = intl.formatMessage({
    id: 'farms.cooperative_society',
  });

  const content = (
    <>
      <span className={`producer-pill-icon ${icon}`}>
        <Icon name={icon} type={'any'} />
      </span>
      <span>
        <FormattedMessage
          id={label}
          values={{ name: <strong>{name}</strong> }}
        />
      </span>
      {cooperative && (
        <Tooltip title={cooperativeTitle}>
          <span className={'producer-pill-badge'}>
            <img src={'/qualityMark/3-09 1.jpg'} alt={cooperativeTitle} />
          </span>
        </Tooltip>
      )}
    </>
  );

  return to ? (
    <Link to={to} className={'producer-pill'}>
      {content}
    </Link>
  ) : (
    <span className={'producer-pill'}>{content}</span>
  );
};

export default ProducerPill;
